import { EmployeeController, PayrollController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { number, object, boolean } from 'yup';
import constant from '../../utils/constant';
import { payrollStore } from '../../stores';
import { ManageProductSalesConfig } from '../../pages';
import React, { useState } from 'react';
import { useFileUpload } from 'use-file-upload';

const ProductSalesConfigContainer = ({ closeModal }) => {
	const [configureSuccess, setConfigureSuccess] = useState(false);
	const [loading, setLoading] = useState(false);
	const [newConfig, setNewConfig] = useState(false);
	const [editConfig, setEditConfig] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();

	const showNewConfig = () => {
		setNewConfig(true);
		setEditConfig(false);
	};

	const showOldConfig = () => {
		setNewConfig(false);
		setEditConfig(false);
	};

	const showEditConfig = () => {
		setEditConfig(true);
	};

	const goBack = () => {
		if (newConfig) {
			showOldConfig();
		} else if (editConfig) {
			setEditConfig(false);
		} else {
			closeModal();
		}
	};

	const showConfigureSuccess = () => {
		setConfigureSuccess(true);
	};
	const validationSchema = () =>
		object({
			point: number()
				.min(1, 'Day of month should be greater than zero')
				.required('Enter Point Value')
		});

	const onUpdateSubmit = async data => {
		setLoading(true);

		const {
			status,
			errorMessage,
		} = await PayrollController.updateProductsConfig(
			data,
			payrollStore.selectedProductSale._id
		);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		setLoading(false);
	};


	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	const onSubmit = async () => {
		const formData = new FormData();
		setLoading(true);
		let fileToSend;

		if (typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
		}
		if (!fileToSend) {
			setLoading(false);
			return MimaToastUtil.error({
				message: 'Kindly select a file',
			});
		}
		formData.append('products', fileToSend);
		const { status, errorMessage } =
			await PayrollController.uploadProductsConfig(formData);
		if (status === constant.Success) {
			setUploaded(true);
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		setLoading(false);

	};

	return (
		<ManageProductSalesConfig
			closeModal={closeModal}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			configureSuccess={configureSuccess}
			showConfigureSuccess={showConfigureSuccess}
			newConfig={newConfig}
			showNewConfig={showNewConfig}
			showOldConfig={showOldConfig}
			editConfig={editConfig}
			showEditConfig={showEditConfig}
			onUpdateSubmit={onUpdateSubmit}
			goBack={goBack}
			uploaded={uploaded}
			file={file}
			selectClick={selectClick}
		/>
	);
};

export default ProductSalesConfigContainer;
